import { motion } from "framer-motion";
import { IMAGES } from "../lib/config";
import { Waves, Trophy, Users, Music, Gamepad2 } from "lucide-react";

const ACTIVITIES = [
  {
    title: "Piscina",
    desc: "Refréscate con tus hermanos en la piscina del campamento",
    image: IMAGES.pool,
    icon: Waves,
    color: "from-cyan-400 to-blue-600",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    title: "Baloncesto",
    desc: "Canchas abiertas todo el día",
    image: IMAGES.basketball,
    icon: Trophy,
    color: "from-orange-400 to-red-600",
    span: "md:col-span-5",
  },
  {
    title: "Bolibol",
    desc: "Torneos por equipos",
    image: IMAGES.volleyball,
    icon: Gamepad2,
    color: "from-green-400 to-emerald-600",
    span: "md:col-span-5",
  },
  {
    title: "Juegos y Dinámicas",
    desc: "Diversión sin parar",
    image: IMAGES.games,
    icon: Users,
    color: "from-yellow-400 to-orange-500",
    span: "md:col-span-7",
  },
  {
    title: "Noche Worship",
    desc: "Adoración bajo las estrellas con luces, música y un mensaje que tocará tu corazón",
    image: IMAGES.worship,
    icon: Music,
    color: "from-purple-500 to-fuchsia-600",
    span: "md:col-span-12",
    big: true,
  },
];

export default function Activities() {
  return (
    <section id="actividades" className="relative bg-gradient-to-br from-orange-50 via-yellow-50 to-pink-50 py-24 lg:py-32 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 bg-black text-yellow-400 text-xs uppercase tracking-[0.4em] font-bold mb-6">
            Habrá muchas actividades
          </span>
          <h2 className="font-heading uppercase text-5xl sm:text-7xl lg:text-8xl text-black leading-[0.9] tracking-tight">
            Vive una <span className="text-orange-600">aventura</span><br />
            que <span className="text-gradient-gold">no olvidarás</span>
          </h2>
          <p className="mt-6 text-lg text-gray-700 max-w-2xl mx-auto">
            Días llenos de adrenalina, risas, amistades nuevas y momentos de adoración que marcarán tu vida.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 lg:gap-6">
          {ACTIVITIES.map((a, i) => (
            <motion.div
              key={a.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className={`group relative overflow-hidden rounded-2xl card-hover ${a.span} ${
                a.big ? "min-h-[500px]" : "min-h-[280px]"
              }`}
              data-testid={`activity-card-${a.title.toLowerCase().replace(/\s/g, "-")}`}
            >
              <img
                src={a.image}
                alt={a.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className={`absolute inset-0 bg-gradient-to-tr ${a.color} opacity-30 mix-blend-multiply`} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-6 lg:p-8">
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br ${a.color} mb-4 shadow-xl`}>
                  <a.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className={`font-heading uppercase text-white tracking-tight ${a.big ? "text-5xl lg:text-7xl" : "text-3xl lg:text-4xl"}`}>
                  {a.title}
                </h3>
                <p className={`text-white/85 mt-2 ${a.big ? "text-lg max-w-xl" : "text-sm"}`}>{a.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
